import { makeAutoObservable } from 'mobx';
import { ApportionmentSplit, ApportionmentAssignment, ApportionmentApiResponse } from '../../../api/ApportionmentApi';
import { ApportionmentType } from '../../../config/Constants';
import { NegativeIdGenerator } from '../../../utils/NegativeIdGenerator';
import { Apportionment } from './Apportionment';
import { Assignment } from './Assignment';

export class Split {
  split: number = 0;
  subApportionment: Apportionment | Assignment = null;
  valueError: boolean = false;
  
  siblingId: number = NegativeIdGenerator.next();

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: ApportionmentSplit, groupId: number): Split {
    const split = new Split();

    split.split = apiData.split;

    if (apiData.subApportionment.type === ApportionmentType.ASSIGNMENT) {
      split.subApportionment = Assignment.fromApi(apiData.subApportionment as ApportionmentAssignment);
    } else {
      split.subApportionment = Apportionment.fromApi(apiData.subApportionment as ApportionmentApiResponse, groupId);
    }
    split.siblingId = apiData.siblingId;

    return split;
  }

  toApi = (): ApportionmentSplit => ({
    split: this.split,
    subApportionment: this.subApportionment.toApi(),
    siblingId: this.siblingId,
  });


  // Technically, a split could contain a multi-entity split
  // but in reality that shouldn't happen, and it's convenient
  // to have a simple way to fetch the organisation id for a split
  get entityId(): number {
    return this.subApportionment.type === ApportionmentType.ASSIGNMENT
      ? this.subApportionment.entityId
      : (this.subApportionment as Apportionment).splits[0]?.entityId;
  }

  set entityId(id: number) {
    if (this.subApportionment.type === ApportionmentType.ASSIGNMENT) {
      (this.subApportionment as Assignment).entityId = id;
    } else {
      (this.subApportionment as Apportionment).splits.forEach(split => split.entityId = id);
    }
  }
}
